import React, { useState } from "react";

import Moment from "moment";

import Languages from "../../../../translations";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

const cellStyle = { borderBottom: "none", color: "black" };

const LeopsGeneralSection = ({
  generalPart,
  formGeneralPart,
  childName,
  SSN,
}) => {
  const [prerequisitesOpen, setPrerequisitesOpen] = useState(false);
  const [groupVasuOpen, setGroupVasuOpen] = useState(false);

  if (!generalPart) return null;

  // Use formGeneralPart for support-plan-specific info, generalPart for shared info
  const gp = formGeneralPart || generalPart;

  return (
    <React.Fragment>
      <Accordion
        className="painikkeet"
        sx={{
          backgroundColor: "#d9f6ff",
          borderRadius: 0.5,
          mt: 1.5,
          boxShadow: 2,
        }}
        expanded={prerequisitesOpen}
        onChange={() => {
          setPrerequisitesOpen(!prerequisitesOpen);
          setGroupVasuOpen(false);
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          sx={{ "&:hover": { bgcolor: "#7bb2c9" } }}
        >
          <Typography
            className="heading"
            sx={{ color: "#424242", fontWeight: "Bold", ml: 2 }}
          >
            {Languages.Preinformation1}
          </Typography>
        </AccordionSummary>
        <div style={{ backgroundColor: "#ffffff" }}>
          <AccordionDetails>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell sx={cellStyle} padding="none" align="left">
                    {Languages.child + ":"}
                  </TableCell>
                  <TableCell sx={{ ...cellStyle, pl: "20px" }} align="left">
                    {childName}
                  </TableCell>
                </TableRow>

                {SSN && (
                  <TableRow>
                    <TableCell sx={cellStyle} padding="none" align="left">
                      {Languages.childsBirthdate + ":"}
                    </TableCell>
                    <TableCell sx={{ ...cellStyle, pl: "20px" }} align="left">
                      {SSN}
                    </TableCell>
                  </TableRow>
                )}

                {gp.PreschoolPlanMade && (
                  <TableRow>
                    <TableCell sx={cellStyle} padding="none" align="left">
                      {Languages.PreschoolPlanCreated + ":"}
                    </TableCell>
                    <TableCell sx={{ ...cellStyle, pl: "20px" }} align="left">
                      {gp.PreschoolPlanMade}
                    </TableCell>
                  </TableRow>
                )}

                <TableRow>
                  <TableCell sx={cellStyle} padding="none" align="left">
                    {Languages.guardian + " 1:"}
                  </TableCell>
                  <TableCell sx={{ ...cellStyle, pl: "20px" }} align="left">
                    {generalPart.Parent1Name}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell sx={cellStyle} padding="none" align="left">
                    {Languages.guardian + " 2:"}
                  </TableCell>
                  <TableCell sx={{ ...cellStyle, pl: "20px" }} align="left">
                    {generalPart.Parent2Name}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell
                    sx={cellStyle}
                    colSpan={2}
                    padding="none"
                    align="left"
                  >
                    <br />
                    <strong>{Languages.leopsInvoledPeople}</strong>
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell sx={cellStyle} padding="none" align="left">
                    {Languages.EarlyEduTeacher + ":"}
                  </TableCell>
                  <TableCell sx={{ ...cellStyle, pl: "20px" }} align="left">
                    {gp.ECETeacher || generalPart.ECETeacher}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell sx={cellStyle} padding="none" align="left">
                    {Languages.otherParticipants + ":"}
                  </TableCell>
                  <TableCell sx={{ ...cellStyle, pl: "20px" }} align="left">
                    {gp.OtherPersons || generalPart.OtherPersons}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell sx={cellStyle} padding="none" align="left">
                    {Languages.creationDate + ":"}
                  </TableCell>
                  <TableCell sx={{ ...cellStyle, pl: "20px" }} align="left">
                    {Moment(gp.CreationDate || generalPart.CreationDate).format(
                      "DD.MM.YYYY",
                    )}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </AccordionDetails>
        </div>
      </Accordion>

      {(generalPart.GroupVasuCriteria || generalPart.GroupVasuObjectives) && (
        <Accordion
          className="painikkeet"
          sx={{
            backgroundColor: "#d9f6ff",
            borderRadius: 0.5,
            mt: -0.5,
            boxShadow: 2,
          }}
          expanded={groupVasuOpen}
          onChange={() => {
            setGroupVasuOpen(!groupVasuOpen);
            setPrerequisitesOpen(false);
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{ "&:hover": { bgcolor: "#7bb2c9" } }}
          >
            <Typography
              className="heading"
              sx={{ color: "#424242", fontWeight: "Bold", ml: 2 }}
            >
              {Languages.Preinformation2}
            </Typography>
          </AccordionSummary>
          <div style={{ backgroundColor: "#ffffff" }}>
            <AccordionDetails>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell sx={cellStyle} padding="none" align="left">
                      {Languages.vasuValues + ":"}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={cellStyle} padding="none" align="left">
                      {generalPart.GroupVasuCriteria}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={cellStyle} padding="none" align="left">
                      {Languages.groupObjectives + ":"}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={cellStyle} padding="none" align="left">
                      {generalPart.GroupVasuObjectives}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={cellStyle} padding="none" align="left">
                      {Languages.GroupLearningSupport + ":"}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={cellStyle} padding="none" align="left">
                      {generalPart.GroupVasuLearningSupport}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={cellStyle} padding="none" align="left">
                      {Languages.GroupSpecificSupport + ":"}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={cellStyle} padding="none" align="left">
                      {generalPart.GroupVasuSpecificSupportMethods}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </AccordionDetails>
          </div>
        </Accordion>
      )}
    </React.Fragment>
  );
};

export default LeopsGeneralSection;
